module.exports = __webpack_public_path__ + "img/login-image.a48cb248.jpg";